// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"75fc64de","521":"75fc64de","703":"75fc64de","736":"75fc64de"}[chunkId] + ".chunk.css";
};